import {configureStore} from '@reduxjs/toolkit'
import {useDispatch} from 'react-redux'
import detailsSlice from './detailsSlice'

export const storeOptions = {
  reducer: {
    details: detailsSlice.reducer,
  },
}

const store = configureStore(storeOptions)

export default store
export type RootState = ReturnType<typeof store.getState>
export type InProductSupportDispatch = typeof store.dispatch

export const useInProductSupportDispatch = (): InProductSupportDispatch => {
  return useDispatch<InProductSupportDispatch>()
}
